"use client";

// import { getAOSAnimation } from "@litonarefin/utils/getAOSAnimation";
import { Fragment, useEffect, useRef, useState } from "react";
import { getBorderCSS, getBorderRadiusCSS } from "@litonarefin/utils/getBorderCSS";
import { getIcon } from "@litonarefin/utils/icons/index";
import Link from "next/link";
import { cn } from "@litonarefin/utils";
import BundlePaddleCheckout from "./BundlePaddleCheckout";
import Image from "next/image";
import { bundlePricingAttributes } from "./bundlePricingAttributes";
// import getMinifyCSS from "@litonarefin/utils/getMinifyCSS";

// checkoutQueries is one encrypted checkout query per tab, in tab order, built by
// the server BlockRenderer. It cannot be built here — this is a client component
// and the AES key is server-only.
const BundlePricing = ({ checkoutQueries = [] }) => {
  const attributes = bundlePricingAttributes;

  const {
    className,
    borders,
    borderRadius,
    buttonPosition,
    offerStyle,
    buttonStyle,
    featuresStyle,
    tabs,
    // OLD
    headerBg,
    bgOverlayColor,
    overlayOpacity,
    subtitleColor,
    priceColor,
    featureTextColor,
    titleColor,
    isActive = false,
    activeText = "UP to 60% off",
    activeStyle = "default",
    activeColor,
    activeBg = "#16213e",
    activeWidth = "auto",
    activeRadius = 8,
    activePosition = "center",
    bgImageURL,
    footerBg,
  } = attributes;

  const [activeTabIndex, setActiveTabIndex] = useState(2);

  return (
    <Fragment>
      <div
        {...(attributes?.anchor && { id: attributes?.anchor })}
        // {...allAOS}
        className={`jlt-pricing-wrapper jlt-flex jlt-flex-col jlt-justify-between jlt-bg-white jlt-h-full jlt-relative${
          className ? ` ${className}` : ""
        }${activeStyle === "right_corner" ? `jlt-overflow-hidden` : ""} `}
      >
        {bgOverlayColor ? (
          <div className="jlt__overlay jlt-absolute jlt-top-0 jlt-left-0 jlt-w-full jlt-h-full jlt-z-[2]" />
        ) : null}

        {isActive && activeStyle === "default" && (
          <div className="jlt-feature-label jlt-absolute jlt-bottom-full jlt-text-center jlt-py-1 jlt-px-8 jlt-box-border">
            <span className="jlt-py-1 jlt-font-bold jlt-text-xs jlt-leading-4">{activeText}</span>
          </div>
        )}

        {activeStyle === "right_corner" ? (
          <div
            style={{ background: activeBg }}
            className="jlt-absolute jlt-z-40 jlt-rotate-45 -jlt-right-9 jlt-top-[26px] jlt-w-[146px] jlt-text-center jlt-text-sm jlt-p-[2px]"
          >
            <span style={{ color: activeColor }}>{activeText}</span>
          </div>
        ) : null}

        {/* Offer  */}
        {tabs[activeTabIndex]?.offerText && (
          <Offer text={tabs[activeTabIndex].offerText} offerStyle={offerStyle} />
        )}

        <div className="jlt-pricing-content jlt-w-full jlt-z-[2]">
          {/* Tabs */}
          <div className="jlt-pt-5 jlt-pb-[10px] jlt-px-6 jlt-flex jlt-justify-end">
            <div className="jlt-bg-white jlt-p-0.5 jlt-inline-flex jlt-gap-2 jlt-rounded-[40px] jlt-switcher-btns jlt-border">
              {tabs
                .map((tab) => tab.tabTitle)
                .map((tab, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveTabIndex(index)}
                    className={cn(
                      "jlt-relative jlt-rounded-[40px] jlt-shadow-[0px_0px_20px0_rgba(173,173,188,0.15)] jlt-text-xs jlt-font-medium jlt-py-1 jlt-px-2.5 jlt-border-none jlt-block jlt-cursor-pointer",
                      activeTabIndex === index
                        ? "jlt-bg-[--primary] jlt-text-white jlt-switcher-active-btn"
                        : "",
                    )}
                  >
                    <span>{tab}</span>
                  </button>
                ))}
            </div>
          </div>

          <TabContent tab={tabs[activeTabIndex]} />

          <PricingButton
            button={tabs[activeTabIndex].button}
            checkoutQuery={checkoutQueries?.[activeTabIndex]}
            buttonStyle={buttonStyle}
          />

          <Features
            features={tabs[activeTabIndex].features}
            featuresButton={{
              ...featuresStyle,
              featureBtnText: tabs[activeTabIndex].featureBtnText,
              featureBtnURL: tabs[activeTabIndex].featureBtnURL,
            }}
          />
        </div>
      </div>

      <style jsx>{`
        .jlt-pricing-wrapper {
          ${borders ? getBorderCSS(borders) : ""}
          ${borderRadius ? getBorderRadiusCSS(borderRadius) : ""}
                        ${bgImageURL
            ? `background: url(${bgImageURL}); background-size: cover; background-position: center; background-repeat: no-repeat;`
            : ""}
                    
                        > .jlt__overlay {
            ${bgOverlayColor ? `background-color: ${bgOverlayColor};` : ""}
            ${overlayOpacity ? `opacity: ${overlayOpacity};` : ""}
          }

          .jlt-pricing-content {
            > .jlt-pricing-head {
              ${headerBg ? `background: ${headerBg};` : ""}
              .jlt_pricing__title {
                ${titleColor ? `color: ${titleColor};` : ""}
              }
              .jlt_pricing__subtitle {
                ${subtitleColor ? `color: ${subtitleColor};` : ""}
              }
              .jlt_pricing__price {
                .jlt_pricing__price-symbol {
                  sup {
                    ${priceColor ? `color: ${priceColor};` : ""}
                  }
                }
                h3,
                span {
                  ${priceColor ? `color: ${priceColor};` : ""}
                }
              }
            }
            .jlt-pricing-features {
              .jlt_feature {
                .jlt_feature__text {
                  ${featureTextColor ? `color: ${featureTextColor};` : ""}
                }
              }
            }
          }
          .jlt-pricing-footer {
            ${footerBg ? `background: ${footerBg};` : ""}
          }
          .jlt-feature-label {
            ${activeColor ? `color: ${activeColor};` : "color: #fff;"}
            ${activeBg ? `background: ${activeBg};` : ""}
                        ${activeRadius
              ? `border-top-left-radius: ${activeRadius}px; border-top-right-radius: ${activeRadius}px;`
              : ""}
                            ${activeWidth
              ? activeWidth === "100%"
                ? `width: 100%;`
                : "width: fit-content;"
              : ""}
                            ${activePosition === "left" || activePosition === "center"
              ? `left: 0;`
              : ""}
                            ${activePosition === "right" || activePosition === "center"
              ? `right: 0;`
              : ""}
                            ${activePosition === "center" ? "margin: auto;" : ""}
          }
        }
      `}</style>
    </Fragment>
  );
};

export default BundlePricing;

const TabContent = ({ tab }) => {
  return (
    <div className="jlt-pricing-head jlt-py-8 jlt-px-6">
      <h3 className="jlt-font-bold jlt-text-2xl jlt_pricing__title">{tab.title}</h3>
      {/* <p className="jlt-mt-2 jlt-text-sm jlt-text-[#40444e] jlt_pricing__subtitle">
        {tab.subtitle}
      </p> */}
      <div className="jlt-mt-4">
        <small className="jlt-line-through">{tab.normalPrice}</small>
      </div>
      <div className="jlt-flex jlt-items-center  jlt_pricing__price">
        <div className="jlt_pricing__price-symbol">
          <sup className="-jlt-mt-2 jlt-text-xs jlt-leading-[18px] jlt-text-[#16213e] jlt-block">
            $
          </sup>
        </div>

        <h3
          className="jlt-font-bold jlt-text-[32px] jlt-leading-[40px] jlt-text-[#16213e] jlt-mr-2"
          dangerouslySetInnerHTML={{ __html: tab?.price || "" }}
        />
        <span
          className="jlt-text-xs jlt-leading-[18px] jlt-text-[#40444e]"
          dangerouslySetInnerHTML={{
            __html: "/ " + tab.duration || "",
          }}
        />
      </div>
      <small>{tab.savePrice}</small>
    </div>
  );
};

const Features = ({ features, featuresButton }) => {
  return (
    <div className="jlt-pricing-features jlt-py-8 jlt-px-6">
      <ul className="jlt-flex jlt-flex-col jlt-gap-y-4">
        {features?.map((feature, index) => (
          <li key={index} className="jlt-list-none jlt-flex jlt-items-center jlt_feature">
            {feature?.link ? <FeatureItemWithLink feature={feature} /> : <FeatureItem feature={feature} />}
          </li>
        ))}
      </ul>

      {featuresButton?.featureBtnText ? (
        <Link
          style={{ color: featuresButton.color }}
          href={
            featuresButton?.featureBtnURL?.link ? `${featuresButton?.featureBtnURL?.link}` : "#"
          }
          className="jlt-mt-4 jlt-font-bold jlt-text-xs jlt-leading-4 jlt-py-2 jlt-px-5 jlt-rounded-sm jlt-bg-none jlt-inline-flex jlt-items-center jlt-no-underline"
        >
          <span className="jlt-mr-2">{featuresButton?.featureBtnText}</span>
          <svg
            className="jlt-mt-[2px]"
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464466C8.97631 0.269204 8.65973 0.269204 8.46447 0.464466C8.2692 0.659728 8.2692 0.976311 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM0 4.5H12V3.5H0V4.5Z"
              fill={` ${featuresButton.color ? featuresButton.color : "#256EFF"}`}
            />
          </svg>
        </Link>
      ) : null}
    </div>
  );
};

const PricingButton = ({ button, checkoutQuery = "", buttonStyle }) => {
  return (
    <>
      {buttonStyle.position === "bottom" ? <hr className="jlt-mx-6" /> : null}
      {buttonStyle.position === "top" ? (
        <div className="jlt-px-6 -jlt-mt-4">
          <BundlePaddleCheckout attributes={{ ...button, checkoutQuery }} />
        </div>
      ) : null}
    </>
  );
};

export const Offer = ({ text, offerStyle }) => {
  return (
    <div className="jlt-offer-label jlt-absolute jlt-text-center jlt-p-[2px_16px_4px] jlt-box-border jlt-z-[999]">
      <span className="jlt-py-1 jlt-font-bold jlt-text-xs jlt-leading-4">{text}</span>

      <style jsx>{`
        .jlt-offer-label {
          ${offerStyle?.background ? `background: ${offerStyle.background};` : ""}
          ${offerStyle?.color ? `color: ${offerStyle.color};` : ""}
          ${offerStyle?.borderRadius ? getBorderRadiusCSS(offerStyle?.borderRadius) : ""}

          ${offerStyle.position === "top"
            ? `left: 0; right: 0; margin: auto; width: fit-content; ${
                offerStyle?.positionY ? `top: ${offerStyle.positionY}px;` : "top: -20px;"
              } ${offerStyle?.positionX ? `left: ${offerStyle.positionX}px;` : ""}`
            : ""}

          ${offerStyle.position === "left"
            ? `left: 0; ${
                offerStyle?.positionY ? `top: ${offerStyle.positionY}px;` : "top: 20px;"
              } ${offerStyle?.positionX ? `left: ${offerStyle.positionX}px;` : ""}`
            : ""}

          ${offerStyle.position === "right"
            ? `right: 0; ${
                offerStyle?.positionY ? `top: ${offerStyle.positionY}px;` : "top: 20px;"
              } ${offerStyle?.positionX ? `left: ${offerStyle.positionX}px;` : ""}`
            : ""}
        }
      `}</style>
    </div>
  );
};

const FeatureItem = ({ feature }) => {
  return <FeatureItemContent feature={feature} />;
};

const FeatureItemWithLink = ({ feature }) => {
  return (
    <a href={feature.link} target="_blank" className="jlt-text-[--primary] jlt-font-medium hover:jlt-text-[#475467] jlt-transition-all jlt-duration-150 jlt-flex">
      <FeatureItemContent feature={feature} />
    </a>
  );
};

const FeatureItemContent = ({ feature }) => {
  return (
    <>
      {feature?.icon ? (
        <Image src={feature.icon} width={20} height={20} alt={feature?.label ? `${feature.label} Icon` : "Feature Icon"} />
      ) : (
        <span>{feature.active ? getIcon("check") : getIcon("close")}</span>
      )}

      <span
        className="jlt-ml-2 jlt-text-sm jlt_feature__text"
        style={feature?.icon && !feature.active ? { textDecorationLine: "line-through" } : {}}
      >
        {feature.label}
      </span>
    </>
  );
};
